// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__176jo","name":"styles_name__1Olh2","phone":"styles_phone__2vkf5"};